<section>
    <div class="help-popup-box">
        <div class="label">
            <span>Need Help ?</span>
        </div>
        <div class="help-option" (click)="raiseTicket()">
            <mat-icon class="help-icon">help</mat-icon>
            <span>Raise a Ticket</span>
            <mat-icon class="arrow-icon">chevron_right</mat-icon>
        </div>
        <!--
        <div class="help-option margin-btm-12" (click)="callUs()">
            <mat-icon class="help-icon">call</mat-icon>
            <span>Call us on +91-80681 72518</span>
            <mat-icon class="arrow-icon">chevron_right</mat-icon>
        </div>
        -->
        <div class="help-option margin-btm-12" (click)="chatwithUs()">
            <mat-icon class="help-icon">chat</mat-icon>
            <span>Chat with us</span>
            <mat-icon class="arrow-icon">chevron_right</mat-icon>
        </div>

    </div>
</section>